import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export default function UnsuccessfulDeleteComment() {
    const modalTitle = <Typography>Leider kam es zu einem Fehler!</Typography>;
    const modalContent = (
        <ContentTypography>
            Der Beitrag konnte nicht erfolgreich entfernt werden. Bitte
            versuchen Sie es erneut.
        </ContentTypography>
    );

    return { modalTitle, modalContent, autoClosingModal: true };
}
